import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

import { FeatureTogglesApiModel } from './feature-toggles-api.model';

@Injectable({
    providedIn: 'root',
})
export class FeatureTogglesService {
    private apiFeatureToggles$: Observable<FeatureTogglesApiModel[]>;

    getApiFeatureToggles$(): Observable<FeatureTogglesApiModel[]> {
        if (!this.apiFeatureToggles$) {
            this.apiFeatureToggles$ = this.getApiFeatureToggles().pipe(shareReplay(1));
        }
        return this.apiFeatureToggles$;
    }

    constructor(private readonly httpClient: HttpClient) {}

    getApiFeatureToggles(): Observable<FeatureTogglesApiModel[]> {
        const headers = new HttpHeaders().set('Content-Type', 'text/plain; charset=utf-8');
        return this.httpClient.get<FeatureTogglesApiModel[]>(this.myFeatureTogglesUrl, { headers });
    }

    hasToggleEnabled$(toggle: string): Observable<boolean> {
        return this.getApiFeatureToggles$().pipe(
            map((toggles): boolean => {
                return toggles.some((x) => x.technicalName === toggle && x.enabled);
            }),
        );
    }

    private get myFeatureTogglesUrl() {
        return `/feature-toggles/me`;
    }
}
